<template>
  <div v-loading="isLoading" class="padded" :role="fetchError ? 'alert' : 'status'">
    <request-details v-if="actionData && actionData.id" :row-data="actionData" :skip-initial-fetch="true" :tab="tab" :subtab="subtab" />
    <template v-else-if="!isLoading">
      <el-alert
        v-if="fetchError"
        type="error"
        :closable="false"
        show-icon
        title="Couldn't load request">
        <span>
          Failed to load the request
          <template v-if="fetchError !== 'network'"> (HTTP {{ fetchError }})</template>
          <template v-else> — network error</template>.
        </span>
        <el-button size="small" style="margin-top: 8px;" @click="fetch">Retry</el-button>
      </el-alert>
      <el-alert
        v-else
        type="info"
        :closable="false"
        show-icon
        title="Request not available">
        <span>This request may not exist, or it belongs to an organisation you don't have access to.</span>
        <el-button size="small" style="margin-top: 8px;" @click="goBack">Back to Requests</el-button>
      </el-alert>
    </template>
    <!-- Root left intentionally spacious for future <request-tabs> drop-in above <request-details>
         (XOL-209 §8 — sub-tab routing reserved, not wired in this PR). -->
  </div>
</template>

<script>
/*
 * L1 layer content for the `d.request.<id>` drawer entry registered in
 * `src/lib/drawerRegistry.js`. Fetches action by id and renders RequestDetails.
 *
 * Envelope note: GET /actions/{id} returns `response($action)` — unwrapped.
 * Use res.data directly, NOT res.data.data (contrast: /site/{id} uses .data.data).
 */
import axios from '@/lib/axiosClient'

import SiteMixins from '@/mixins/SiteMixins'
import RequestDetails from '@/components/requests/RequestDetails'

export default {
  mixins: [SiteMixins],

  components: {
    RequestDetails
  },

  props: {
    actionId: {
      type: Number,
      required: true
    },
    // Forwarded for forward-compatibility with future sub-tab routing.
    // Not consumed by RequestDetails in this PR.
    tab: {
      type: String,
      default: null
    },
    subtab: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      actionData: null,
      isLoading: true,
      fetchError: null
    }
  },

  watch: {
    actionId: {
      handler: 'fetch',
      immediate: true
    }
  },

  methods: {
    fetch () {
      this.isLoading = true
      this.fetchError = null
      this.actionData = null

      // /actions/{id} returns response($action) — bare, not enveloped in {data: ...}
      axios.get(this.getEndpoint('/actions/' + this.actionId))
        .then(function (res) {
          var data = res.data
          if (data && data.id) {
            this.actionData = data
          } else {
            this.actionData = null
          }
        }.bind(this))
        .catch(function (err) {
          this.actionData = null
          this.fetchError = err.response ? err.response.status : 'network'
        }.bind(this))
        .finally(function () {
          this.isLoading = false
        }.bind(this))
    },

    goBack () {
      var slug = this.$route.params.typeSlug || 'summary'
      this.$router.push({ path: '/requests/' + slug, query: this.$route.query })
    }
  }
}
</script>
